import { getNavigatorLanguage } from './get-navigator-language';
import { loadRegion } from './load-region';
import { PROD_DEFAULT_LANGUAGE } from './supported-languages';

export function inferLanguageFromNavigator(): string {
  const navigatorLanguage = getNavigatorLanguage();
  // If language not set return default language
  return navigatorLanguage.split(/.*-/)[0] || String(PROD_DEFAULT_LANGUAGE[loadRegion()]);
}
